<app-customer-header [profileDetails]="profileUpdate"></app-customer-header>
<div class="container">
  <p class="breadcrums arrow" (click)="GoToDashboard()">
    <span class="material-icons">arrow_back_ios_new</span>
    Back to Dashboard
  </p>
  <mat-card class="card-container profile-component">
    <div class="row">
      <!-- Profile Pic Update  -->
      <div class="col-md-4">
        <mat-card-content class="card-container-right">
          <div layout="column">
            <div [class.spinner]="profileLoading"></div>

            <img
              mat-card-sm-image
              src="{{ profileImage ? profileImage : '' }}"
            />
            <div class="update-profile" *ngIf="profileUpdateButton">
              <button
                mat-raised-button
                type="button"
                [class.spinner]="loading"
                [disabled]="loading"
                (click)="fileInput.click()"
              >
                <span>Update Profile Picture </span>
              </button>
              <input #fileInput type="file" style="display: none" (change)="onChange($event)" />
            </div>

            <div class="change-password">
              <button
                mat-raised-button
                type="button"
                style="background-color: red"
                [class.spinner]="loading"
                [disabled]="loading"
                (click)="deleteaccount(data.mobile)"
              >
                <span class="delete">Delete My Account </span>
              </button>
            </div>
            <div class="change-password" *ngIf="save">
              <button
                [class.spinner]="loading"
                [disabled]="loading"
                type="button"
                mat-raised-button
                color="warn"
                (click)="updateProfile()"
              >
                Save
              </button>
            </div>
            <div class="change-password" *ngIf="billingSave">
              <button
                [class.spinner]="loading"
                [disabled]="loading"
                (click)="updateBillingAddress()"
                type="button"
                mat-raised-button
                color="warn"
              >
                Save
              </button>
            </div>
          </div>
        </mat-card-content>
      </div>
      <!-- General Account Details -->
      <div class="col-md-8 input-fileds-container">
        <mat-card-content class="card-container-left">
          <form [formGroup]="profileForm">
            <div layout="column">
              <div class="card-details-container">
                <div class="card-details-header">
                  <h3>General Account Details</h3>
                  <a (click)="onEditProfile(1)" *ngIf="edit1">Edit</a>
                </div>
                <div class="card-details">
                  <div class="card-details-left">
                    Name
                    <span *ngIf="editGeneralInfo" style="color: brown">*</span>
                  </div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ this.data.username }}
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input
                        matInput
                        formControlName="userName"
                        style="text-transform: capitalize"
                        required
                      />
                      <mat-error
                        *ngIf="(ProfileFormControl['userName'].touched) && ProfileFormControl['userName'].errors?.['pattern']"
                      >
                        Please Enter Valid Name</mat-error
                      >
                      <mat-error
                        *ngIf="(ProfileFormControl['userName'].touched) && ProfileFormControl['userName'].errors?.['required']"
                      >
                        Name is Required</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">Contact</div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ this.data.mobile }}
                    <span *ngIf="mobileVerified === 0">
                      <img src="../../../assets/img/error.svg" />
                      <a style="color: brown; cursor: pointer">Send OTP</a>
                    </span>
                    <img
                      src="../../../assets/img/tick-verify.svg"
                      *ngIf="mobileVerified > 0"
                    />
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input matInput formControlName="mobile" readonly />
                      <mat-error>Please Enter Valid Mobile Number</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">
                    Email Id
                    <span *ngIf="editGeneralInfo" style="color: brown">*</span>
                  </div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ this.data.email }}
                    <span *ngIf="emailVerified === 0">
                      <img src="../../../assets/img/error.svg" />
                      <a style="color: brown">Send OTP</a>
                    </span>
                    <img
                      src="../../../assets/img/tick-verify.svg"
                      *ngIf="emailVerified > 0"
                    />
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input matInput formControlName="email" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">Date of Birth</div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ this.data.dob | date : "dd-MM-yyyy" }}
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input
                        matInput
                        [matDatepicker]="picker"
                        [max]="maxDate"
                        formControlName="dateOfBirth"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                      <mat-error
                        *ngIf="
                          ProfileFormControl['dateOfBirth'].touched &&
                          invalidDate
                        "
                      >
                        Please enter valid Date of Birth</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">Gender</div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ this.data.gender }}
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field appearance="fill">
                      <mat-select formControlName="gender" style="width: 100%">
                        <mat-option>Select Gender</mat-option>
                        <mat-option value="male">Male</mat-option>
                        <mat-option value="female">Female</mat-option>
                        <mat-option value="others">Others</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">Company Name</div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ this.data.company_name }}
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input
                        matInput
                        style="text-transform: capitalize"
                        formControlName="companyName"
                      />
                      <mat-error
                        *ngIf="(ProfileFormControl['companyName'].touched) && ProfileFormControl['companyName'].errors?.['pattern']"
                      >
                        Please Enter Valid Comapny Name</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">Designation</div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ this.data.designation }}
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input matInput formControlName="designation" />
                      <mat-error>Please Enter Valid Mobile Number</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <!-- <div class="card-details">
                  <div class="card-details-left">GST</div>
                  <div class="card-details-right" *ngIf="!editGeneralInfo">
                    {{ this.data.gst }}
                  </div>
                  <div class="card-details-right" *ngIf="editGeneralInfo">
                    <mat-form-field>
                      <input
                        matInput
                        appAlphanumericOnly
                        toUppercase
                        formControlName="gst"
                        minlength="15"
                        maxlength="15"
                        formControlName="gst"
                      />
                      <mat-error
                        *ngIf="(ProfileFormControl['gst'].touched) && ProfileFormControl['gst'].errors?.['pattern']"
                      >
                        Please Enter Valid GST</mat-error
                      >
                      <mat-error
                        *ngIf="(ProfileFormControl['gst'].touched) && ProfileFormControl['gst'].errors?.['maxlength']"
                      >
                        Please Enter Valid GST</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div> -->
              </div>
            </div>
          </form>
          <!-- Billing Details  -->
          <form [formGroup]="billingForm">
            <div layout="column">
              <div class="card-details-container">
                <div class="card-details-header">
                  <h3>Billing Details</h3>
                  <a (click)="onEditBillingAddress()" *ngIf="edit2">Edit</a>
                </div>
                <div class="card-details">
                  <div class="card-details-left">
                    Name
                    <span *ngIf="editBillingDetails" style="color: brown"
                      >*</span
                    >
                  </div>
                  <div class="card-details-right" *ngIf="!editBillingDetails">
                    {{ data.billing_address?.username }}
                  </div>
                  <div class="card-details-right" *ngIf="editBillingDetails">
                    <mat-form-field>
                      <input
                        matInput
                        formControlName="billingName"
                        style="text-transform: capitalize"
                        required
                      />
                      <mat-error
                        *ngIf="(BillingFormControl['billingName'].touched) && BillingFormControl['billingName'].errors?.['pattern']"
                      >
                        Please Enter Valid Name</mat-error
                      >
                      <mat-error
                        *ngIf="(BillingFormControl['billingName'].touched) && BillingFormControl['billingName'].errors?.['required']"
                      >
                        Name is Required</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">
                    Address
                    <span *ngIf="editBillingDetails" style="color: brown"
                      >*</span
                    >
                  </div>
                  <div class="card-details-right" *ngIf="!editBillingDetails">
                    {{ data.billing_address?.address_line }}
                  </div>
                  <div class="card-details-right" *ngIf="editBillingDetails">
                    <mat-form-field>
                      <textarea
                        matInput
                        formControlName="address"
                        required
                      ></textarea>
                      <mat-error
                        *ngIf="(BillingFormControl['address'].touched) && BillingFormControl['address'].errors?.['required']"
                      >
                        Address is Required</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">
                    Area
                    <span *ngIf="editBillingDetails" style="color: brown"
                      >*</span
                    >
                  </div>
                  <div class="card-details-right" *ngIf="!editBillingDetails">
                    {{ data.billing_address?.area_name }}
                  </div>
                  <div class="card-details-right" *ngIf="editBillingDetails">
                    <mat-form-field>
                      <input matInput formControlName="area" required />
                      <mat-error
                        *ngIf="(BillingFormControl['area'].touched) && BillingFormControl['area'].errors?.['required']"
                      >
                        Area is Required</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">
                    City
                    <span *ngIf="editBillingDetails" style="color: brown"
                      >*</span
                    >
                  </div>
                  <div class="card-details-right" *ngIf="!editBillingDetails">
                    {{ data.billing_address?.city }}
                  </div>
                  <div class="card-details-right" *ngIf="editBillingDetails">
                    <mat-form-field>
                      <input matInput formControlName="city" required />
                      <mat-error
                        *ngIf="(BillingFormControl['city'].touched) && BillingFormControl['city'].errors?.['required']"
                      >
                        City is Required</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">
                    State
                    <span *ngIf="editBillingDetails" style="color: brown"
                      >*</span
                    >
                  </div>
                  <div class="card-details-right" *ngIf="!editBillingDetails">
                    {{ data.billing_address?.state }}
                  </div>
                  <div class="card-details-right" *ngIf="editBillingDetails">
                    <mat-form-field>
                      <input matInput formControlName="state" required />
                      <mat-error
                        *ngIf="(BillingFormControl['state'].touched) && BillingFormControl['state'].errors?.['required']"
                      >
                        State is Required</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">
                    Pincode
                    <span *ngIf="editBillingDetails" style="color: brown"
                      >*</span
                    >
                  </div>
                  <div class="card-details-right" *ngIf="!editBillingDetails">
                    {{ data.billing_address?.pincode }}
                  </div>
                  <div class="card-details-right" *ngIf="editBillingDetails">
                    <mat-form-field>
                      <input
                        matInput
                        (keypress)="validateNumber($event)"
                        formControlName="pincode"
                        minlength="6"
                        maxlength="6"
                        required
                      />
                      <mat-error
                        *ngIf="(BillingFormControl['pincode'].touched) && BillingFormControl['pincode'].errors?.['required']"
                      >
                        Pincode is Required</mat-error
                      >
                      <mat-error
                        *ngIf="(BillingFormControl['pincode'].touched) && BillingFormControl['pincode'].errors?.['pattern']"
                      >
                        Please Enter Valid Pincode</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">
                    Contact
                    <span *ngIf="editBillingDetails" style="color: brown"
                      >*</span
                    >
                  </div>
                  <div class="card-details-right" *ngIf="!editBillingDetails">
                    {{ data.billing_address?.mobile }}
                  </div>
                  <div class="card-details-right" *ngIf="editBillingDetails">
                    <mat-form-field>
                      <input
                        matInput
                        (keypress)="validateNumber($event)"
                        (paste)="onPasteNumber($event)"
                        formControlName="billingContact"
                        minlength="10"
                        maxlength="10"
                        required
                      />
                      <mat-error
                        *ngIf="(BillingFormControl['billingContact'].touched) && BillingFormControl['billingContact'].errors?.['required']"
                      >
                        Mobile Number is Required</mat-error
                      >
                      <mat-error
                        *ngIf="(BillingFormControl['billingContact'].touched) && BillingFormControl['billingContact'].errors?.['pattern']"
                      >
                        Please Enter Valid Mobile Number</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="card-details">
                  <div class="card-details-left">GST</div>
                  <div class="card-details-right" *ngIf="!editBillingDetails">
                    <span>{{ data.billing_address?.gst || 'NA' }}</span>
                    <span *ngIf="data.billing_address?.gst && (data.billing_address?.gst_verified || isGstVerified)" style="margin-left: 8px;">
                      <img src="../../../assets/img/tick-verify.svg" title="Verified with Master India" style="width: 16px; vertical-align: middle;" />
                      <span style="color: #16a34a; font-size: 12px; font-weight: 500; margin-left: 4px;">Verified</span>
                    </span>
                    <span *ngIf="data.billing_address?.gst && !data.billing_address?.gst_verified && !isGstVerified && !isGstVerifying" style="margin-left: 8px;">
                      <img src="../../../assets/img/error.svg" style="width: 14px; vertical-align: middle;" />
                      <a (click)="verifyGST(data.billing_address?.gst)" style="color: #0b5ed7; cursor: pointer; text-decoration: underline; margin-left: 4px; font-weight: 500;">Verify GST</a>
                    </span>
                    <span *ngIf="isGstVerifying && !editBillingDetails" style="margin-left: 8px;">
                      <div class="inline-spinner" style="width: 14px; height: 14px;"></div>
                    </span>
                  </div>
                  <div class="card-details-right" *ngIf="editBillingDetails">
                    <div class="d-flex align-items-center" style="width: 100%;">
                      <mat-form-field style="flex: 1;">
                        <input
                          matInput
                          appAlphanumericOnly
                          toUppercase
                          formControlName="gst"
                          minlength="15"
                          maxlength="15"
                          (input)="onGstChange()"
                          placeholder="Enter 15-digit GSTIN"
                        />
                        <mat-error
                          *ngIf="(BillingFormControl['gst'].touched) && BillingFormControl['gst'].errors?.['pattern']"
                        >
                          Please Enter Valid GST</mat-error
                        >
                        <mat-error
                          *ngIf="(BillingFormControl['gst'].touched) && BillingFormControl['gst'].errors?.['maxlength']"
                        >
                          Please Enter Valid GST</mat-error
                        >
                      </mat-form-field>

                      <div class="gst-verify-btn-wrapper" style="margin-left: 12px; margin-top: -5px; white-space: nowrap;">
                        <div *ngIf="!isGstVerified && !isGstVerifying">
                          <button
                            type="button"
                            mat-stroked-button
                            color="primary"
                            class="btn-verify-gst"
                            (click)="verifyGST(BillingFormControl['gst'].value)"
                            title="Verify GSTIN with Master India"
                          >
                            Verify GST
                          </button>
                        </div>
                        <div *ngIf="isGstVerifying" class="d-flex align-items-center">
                          <div class="inline-spinner"></div>
                          <span style="font-size: 11px; color: #64748b; margin-left: 6px;">Verifying...</span>
                        </div>
                        <div *ngIf="isGstVerified" class="d-flex align-items-center" style="color: #16a34a; font-weight: 500; font-size: 13px;">
                          <img src="../../../assets/img/tick-verify.svg" style="width: 18px; margin-right: 4px;" title="Verified with Master India" />
                          <span>Verified</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </mat-card-content>
      </div>
    </div>
  </mat-card>
</div>
